module.exports = __webpack_public_path__ + "static/media/cart-icon.d549cca1.svg";